<div class="wrapper" *ngIf="Token">


  <!--=================================
   preloader -->

  <div id="pre-loader">
    <img src="assets/Content/images/pre-loader/loader-01.svg" alt="">
  </div>

  <!--=================================
   preloader -->


  <!--=================================
   header start-->

  <nav class="admin-header header-dark navbar navbar-default col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
    <!-- logo -->
    <div class="text-left navbar-brand-wrapper">

      <a class="navbar-brand brand-logo" href="index.html"><img style="height: 50px;" src="assets/Content/logo.png"
          alt=""></a>
      <a class="navbar-brand brand-logo-mini" href="index.html"><img src="assets/Content/icon.png" alt=""></a>

    </div>
    <!-- Top bar left -->
    <ul class="nav navbar-nav mr-auto">
      <li class="nav-item">
        <a id="button-toggle" class="button-toggle-nav inline-block ml-20 pull-left" href="javascript:void(0);"><i
            class="zmdi zmdi-menu ti-align-right"></i></a>
      </li>
      <li class="nav-item">
        <div class="search">
          <a style="font-family: Arial, Helvetica, sans-serif;" class="button-toggle-nav inline-block ml-20 pull-left"
            href="#">Version 6.57.1</a>
        </div>
      </li>
      <li class="nav-item">
        <div class="search">
          <a  class="button-toggle-nav inline-block ml-20 pull-left"
            href="#">04 - 05 - 1404</a>
        </div>
      </li>
      <li class="nav-item" *ngIf="onlineUser.length>0">
        <div class="search">
          <a *ngIf="Type==1" (click)="OnShow_onlineUser(template_OnlineUser)" class="button-toggle-nav inline-block ml-20 pull-left" >{{onlineUser.length}} Online Users </a>
          <a *ngIf="Type!=1" class="button-toggle-nav inline-block ml-20 pull-left" href="#">{{onlineUser.length}} Online Users </a>


        </div>
      </li>
      <li class="nav-item" *ngIf="Type==1 || Type==2">
        <div class="search">
          <a  class="button-toggle-nav inline-block ml-20 pull-left" href="#">This Month {{UserUrl_Min_Month}}</a>
          <a  class="button-toggle-nav inline-block ml-20 pull-left" href="#">Yesterday {{UserUrl_Min_YesterDay}}</a>


        </div>
      </li>
    </ul>
    <!-- top bar right -->
    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link top-nav">{{nowDate}} Time {{nowClock| date:'HH:mm:ss'}}</a>
      </li>


      <li *ngIf="!Comment_Proccessing  && Comment_Show_Button" class="nav-item shakeit" style="cursor: pointer;" (click)="OnShowComment(templateComment)">
        <a class="nav-link top-nav" title="Comments"><i class="fa fa-commenting"></i></a>
        <div class="shakeitText">
          <div class="shakeitTextFirst"></div>
          <div class="shakeitTextSecond">View Comments</div>
        </div>
      </li>
      <li *ngIf="Comment_Show_Button"  class="nav-item" style="cursor: pointer;">
        <a class="nav-link top-nav" routerLink="/CustomerListUser" title="Customers"><i class="fa fa-vcard"></i></a>
      </li>

      <li *ngIf="DevicePersianEngHelp_Show_Button" class="nav-item shakeit" style="cursor: pointer;" (click)="OnShow_DevicePersianEngHelp(template_DevicePersianEngHelp)">
        <a class="nav-link top-nav" title="Search Instruments"><i class="fa fa-cc-amex"></i></a>
        <div class="shakeitText">
          <div class="shakeitTextFirst"></div>
          <div class="shakeitTextSecond">Search Instruments</div>
        </div>
      </li>
      <li *ngIf="Comment_Proccessing" class="nav-item" style="cursor: pointer;" >
        <a class="nav-link top-nav" title="Comments"><i class="fa fa-spin fa-refresh"></i></a>
      </li>



      <li *ngIf="!Help_Proccessing" class="nav-item" style="cursor: pointer;" (click)="OnShowHelp(templateHelp)">
        <a class="nav-link top-nav" title="Help"><i class="fa fa-question-circle-o"></i></a>
      </li>
      <li *ngIf="Help_Proccessing" class="nav-item" style="cursor: pointer;" >
        <a class="nav-link top-nav" title="Help"><i class="fa fa-spin fa-refresh"></i></a>
      </li>



      <li class="nav-item dropdown " *ngIf="DataList_Alert.length>0" style="cursor: pointer;" (click)="Show_All_Alerm()">
        <a class="nav-link top-nav">
          <i class="ti-bell"></i>
        </a>
      </li>
      <li class="nav-item fullscreen">
        <a id="btnFullscreen" style="cursor:pointer ;" class="nav-link"><i class="ti-fullscreen"></i></a>
      </li>
      <li class="nav-item dropdown " style="cursor: pointer;" (click)="openModalPassword(templatePassword)">
        <a class="nav-link top-nav"><i class="fa fa-key"></i></a>
      </li>
      <li class="nav-item dropdown mr-30">
        <a class="nav-link nav-pill user-avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
          aria-expanded="false">
          <img src="{{BaserUrlImage}}" alt="avatar">
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-header">
            <div class="media">
              <div class="media-body">
                <h5 class="mt-0 mb-0">{{Fullname}}</h5>
                <span *ngIf="this.Type=='1'">Administrator</span>
                <span *ngIf="this.Type=='2'">Standard User</span>
                <span *ngIf="this.Type=='3'">Customer User</span>
                <span *ngIf="this.Type=='4'">Customer Representative</span>
              </div>
            </div>
          </div>
          <div class="dropdown-divider"></div>
          <a (click)="OnExit()" class="dropdown-item" href="#"><i class="text-danger ti-unlock"></i>Sign Out</a>
        </div>
      </li>

    </ul>
  </nav>

  <!--=================================
   header End-->

  <!--=================================
   Main content -->

  <div class="container-fluid">
    <div class="row">
      <!-- Left Sidebar start-->
      <div class="side-menu-fixed">
        <div class="scrollbar side-menu-bg">
          <app-Nav></app-Nav>
        </div>

      </div>
      <!-- Left Sidebar End-->

      <!--=================================
   Main content -->

      <!--=================================
  wrapper -->

      <div class="content-wrapper">
        <router-outlet></router-outlet>
        <div style="margin-top: 50px;">
          <a style="font-family: Arial, Helvetica, sans-serif;float:right ;" href="https://moeinattari.ir/"> &copy; Developed in 2022
          </a>

        </div>
        <div style="clear: both;">

        </div>
      </div>
    </div>
  </div>

  <div id="OnlineUser" style="display: none;">
    <p> {{onlineUser}} Users Online <i class="fa fa-user"></i></p>
  </div>

</div>

<div class="wrapper" *ngIf="!Token">
  <app-Login></app-Login>
</div>




<ng-template #templatePassword>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Change Password </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ResetPassword.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Current Password </label>
          <input type="password" class="form-control" [(ngModel)]="CurrentPassword" placeholder=" Type here...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> New Password </label>
          <input type="password" class="form-control" [(ngModel)]="NewPassword" placeholder=" Type here...">
        </div>
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Confirm New Password </label>
          <input type="password" class="form-control" [(ngModel)]="NewRePassword" placeholder=" Type here...">
        </div>
      </div>

    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProccesingPassword" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" *ngIf="!ProccesingPassword" (click)="ResetPassword()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-pencil"></i> Register Information </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ResetPassword.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateHelp>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Help_Nav_Title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Help.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <app-HelpView [DataList_Behfa]="Select_Record_Help"></app-HelpView>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Help.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateComment>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> {{Comment_Nav_Title}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Comment.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Priority</th>
              <th>Registered By</th>
              <th>Registration Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Select_Record_Comment" >
             <td>{{Select_Record_Comment.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>

              <th>
                <p *ngIf="item.code=='0'" style="color: #489b39;">Normal</p>
                <p *ngIf="item.code=='1'" style="color: #9b7439;">Important</p>
                <p *ngIf="item.code=='2'" style="color: #9b394e;">Critical</p>

              </th>

              <td>{{item.username}}</td>
              <td>{{item.persianDate}} </td>
            </tr>
          </tbody>
        </table>
     </div>

     <br />
     <hr />
     <br />


     <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">{{Comment_Nav_Form_Title}}</label>
        <textarea type="text" class="form-control" [(ngModel)]="Comment_Nav_Form_Dsc" placeholder="Type here...">
        </textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <button type="button" *ngIf="!InProccessing" class="btn btn-success" (click)="Submit_Comment()">
          Submit Comment </button>
      </div>
    </div>

     <hr/>

    </div>

  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Comment.hide()">Got It</button>
  </div>
</ng-template>


<div class="TokenStation" *ngIf="Token && Token_Station_Remain<=60">
  <div class="TokenStationCenter">
      <h4>Your authentication session will expire in <span style="color:red ;">{{Token_Station_Remain}}</span> seconds.</h4>
      <br/>
      <button *ngIf="!Token_Station_Proccessing" type="button" class="btn btn-success" (click)="ExtensionTokenStation()"><i class="fa fa-clock-o"></i> Extend Session</button>
      <button *ngIf="Token_Station_Proccessing" type="button" class="btn btn-success" ><i class="fa fa-spin fa-refresh"></i> Please wait... </button>
      <button type="button" style="margin-left:10px ;" (click)="OnExit()" class="btn btn-danger"><i class="fa fa-power-off"></i> Sign Out </button>
  </div>
</div>

<ng-container *ngFor="let item of DataList_Alert">

  <div class="TokenStation" *ngIf="!item.del">
    <div class="TokenStationRight">
        <h4> Notice - {{item.title}}</h4>
        <br/>
        <div  class="acd-des" innerHTML="{{item.message}}"></div>

        <br/>
        <ul>
            <li *ngFor="let file of item.files">
              <a target="_blank" href="{{BaseUrl}}File/Alert/{{file}}"  ><i class="fa fa-download"></i>
                 Attached File No. {{item.files.indexOf(file)+1}}
              </a>
            </li>
        </ul>
        <br/>

        <button type="button" (click)="See_Alert(item)" class="btn btn-danger"><i class="fa fa-eye-slash"></i> Mark as Read </button>
    </div>
  </div>

</ng-container>

<ng-template #template_DevicePersianEngHelp>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Instrument Search Guide </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DevicePersianEngHelp.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Keyword</label>
          <input type="text" class="form-control" name="key_DevicePersianEngHelp"
            [(ngModel)]="key_DevicePersianEngHelp" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>English Name</th>
              <th>Persian Name</th>
              <th>Quantity</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Select_Record_DevicePersianEngHelp">
              <td>{{Select_Record_DevicePersianEngHelp.indexOf(item)+1}}</td>
              <td>{{item['device_name']}}</td>
              <td>{{item['dsc']}}</td>
              <td>{{item['quantity_title']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="DevicePersianEngHelp_Proccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!DevicePersianEngHelp_Proccessing" type="button" (click)="Read_DevicePersianEngHelp()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DevicePersianEngHelp.hide()">Close</button>
  </div>
</ng-template>

<ng-template #template_OnlineUser>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Online Users </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_onlineUser.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>User Title</th>
              <th>Username</th>
              <th>User Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of onlineUser">
              <td>{{onlineUser.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.username}}</td>
              <td>{{item.type}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_onlineUser.hide()">Close</button>
  </div>
</ng-template>
